import { createContext, useContext } from "react";

import { MenuItemEditorState } from "features/MenuItemEditor/hooks/useMenuItemEditorState";

export const MenuItemEditorContext = createContext<MenuItemEditorState | null>(null);

export const useMenuItemEditorContext = (): MenuItemEditorState => {
    const context = useContext(MenuItemEditorContext);
    if (!context) {
        throw new Error("useMenuItemEditorContext должен использоваться внутри MenuItemEditor");
    }
    return context;
};
